function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-38.5626 -38.9776L-4.04095 55.309L10.034 33.5799L-38.5626 -38.9776Z",
  fill: "#99D6EA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.4607 4.96458L25.4024 16.4262L53.7439 0.38501L-38.5627 -38.9776L28.4607 4.96458Z",
  fill: "#FFB81C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3728 14.4174L10.0339 33.5799L17.5722 45.1538L25.4025 16.4262L22.3728 14.4174Z",
  fill: "#99D6EA"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M-38.5628 -38.9776L10.0338 33.5799L22.3728 14.4174L-38.5628 -38.9776Z",
  fill: "#00A9E0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.4023 16.4262L28.4606 4.9646L22.3727 14.4174L25.4023 16.4262Z",
  fill: "#AFA96E"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M28.4607 4.9647L-38.5627 -38.9775L22.3728 14.4175L28.4607 4.9647Z",
  fill: "#A09958"
});

function SvgSvgviewerOutput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 61,
    viewBox: "0 0 59 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgviewerOutput);
export default __webpack_public_path__ + "static/media/svgviewer-output.e02ea5e7.svg";
export { ForwardRef as ReactComponent };